import * as Immutable from 'immutable';
import { StoreProductPayload, StoreProductStore } from '../_stores/Store/StoreProductStore';
import { StoreProductStoreAction, StoreProductStoreActionType } from '../_actions/Store/StoreProductStoreActions';
import StoreProductListStore from '../_stores/Store/StoreProductListStore';
import PaginationItemListStore from '../_stores/PaginationItemListStore';
import { StoreVariantStore } from '../_stores/Store/StoreVariantStore';

const editStoreProduct = (_store: StoreProductListStore, action: StoreProductPayload) => {
  return _store.withMutations(_store => {
    const oldStoreProduct = _store.get('data').get(String(action.id));

    const { listVariants, ...otherProps } = action;

    let newStoreProduct = new StoreProductStore(otherProps);

    if (oldStoreProduct) {
      newStoreProduct = oldStoreProduct.mergeDeep(newStoreProduct);
    }

    if (listVariants) {
      let tmpListVariants = Immutable.OrderedMap<string, StoreVariantStore>();
      Object.values(listVariants).forEach(item => {
        const oldItem = newStoreProduct
          ?.get('listVariants')
          .get(String(item.id))

        const { listOptions, ...otherVariantProps } = item;

        let newItem = new StoreVariantStore(otherVariantProps)

        if (oldItem) {
          newItem = oldItem.mergeDeep(newItem)
        }

        newItem = newItem.set('listOptions', Immutable.OrderedSet(listOptions))

        tmpListVariants = tmpListVariants.set(String(item.id), newItem)
      })

      newStoreProduct = newStoreProduct.set('listVariants', tmpListVariants)
    }

    _store.set('data', _store.get('data').set(String(action.id), newStoreProduct));
  })
}

const StoreProductReducer = (
  _store: StoreProductListStore = new StoreProductListStore(),
  action: StoreProductStoreAction
): StoreProductListStore => {
  switch (action.type) {
    case StoreProductStoreActionType.EditStoreProduct:
      _store = editStoreProduct(_store, action.storeProduct);
      break;

    case StoreProductStoreActionType.EditManyStoreProducts:
      Object.values(action.storeProducts).forEach(storeProduct => {
        _store = editStoreProduct(_store, storeProduct);
      })
      break;

    case StoreProductStoreActionType.EditStoreProductList:
      let items = Immutable.OrderedSet<string>();

      action.data.items.forEach(item => {
        _store = editStoreProduct(_store, item);

        let id = String(item.id);
        items = items.add(id);
      });

      _store = _store.set('itemLists', _store.get('itemLists').set(action.listId, new PaginationItemListStore({
        items: items,
        total: action.data.totalItems,
        valid: true,
        loading: false,
      })));
      break;

    case StoreProductStoreActionType.EditStoreProductListLoader:
      const oldItemList = _store.get('itemLists').get(action.listId);

      let newItemList = new PaginationItemListStore({
        loading: action.loading,
      });

      if (oldItemList) {
        newItemList = oldItemList.set('loading', action.loading);
      }

      _store = _store.set('itemLists', _store.get('itemLists').set(action.listId, newItemList))
      break;

    case StoreProductStoreActionType.InvalidateStoreProducts:
      _store = _store.withMutations(_store => {
        _store.get('itemLists').forEach((itemList, key) => {
          _store.set('itemLists', _store.get('itemLists')
              .set(key, itemList.set('valid', false)));
        });
      });
      break;
  }
  return _store;
}

export default StoreProductReducer
